export default __webpack_public_path__ + "static/media/m8.70ee7331.png";